@if (Open) {
  <mj-slide-panel Mode="dialog" [Title]="''" [Visible]="true" [WidthPx]="720" (Closed)="Close.emit()">
    <!-- The panel's own header is not used: its close button has no accessible name and sits outside any dialog role. -->
    <div dialog-content #Dialog class="oep-emails" role="dialog" aria-modal="true" aria-labelledby="oep-emails-title" tabindex="-1" (keydown)="TrapTab($event)">
      <div class="oep-emails__bar">
        <h2 id="oep-emails-title" class="oep-emails__title">Notification emails</h2>
        <button type="button" class="oep-emails__close" aria-label="Close notification emails" (click)="Close.emit()">✕</button>
      </div>
      <p class="oep-emails__status" role="status" aria-live="polite">
        @if (LoadFailure) { Couldn't load the email templates: {{ LoadFailure }} }
        @else if (!Loaded) { Loading the email templates… }
      </p>
      <ul class="oep-emails__list">
        @for (e of Entries; track e.Key) {
          <li class="oep-emails__entry">
            <div class="oep-emails__head">
              <span class="oep-emails__trigger">{{ e.Trigger }}</span>
              <strong class="oep-emails__subject">{{ e.Subject }}</strong>
            </div>
            <p class="oep-emails__body">{{ e.Body }}</p>
          </li>
        }
      </ul>
    </div>
  </mj-slide-panel>
}
